import { render, staticRenderFns } from "./Segmentation.vue?vue&type=template&id=a2c6fa10&scoped=true"
import script from "./Segmentation.vue?vue&type=script&lang=ts"
export * from "./Segmentation.vue?vue&type=script&lang=ts"
import style0 from "./Segmentation.vue?vue&type=style&index=0&id=a2c6fa10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c6fa10",
  null
  
)

export default component.exports